<template>
  <div class="marginator" v-if="dataLoaded">
    <div class="pre-trade">
      <div v-if="datefor.length == 2 || next">
        <div class="head-main preparation">
          <div class="head-content" id="focusdiary" >
            <v-btn
              v-if="datefor.length < 2"
              @click="next = false"
              class="mr-2"
              color="#b6c1cb"
              outlined
            >
              <v-icon>keyboard_arrow_left</v-icon>back
            </v-btn>

            <v-icon color="#25a7f9">developer_board</v-icon>
            <b class="ml-1">{{today}}</b>
          </div>
          <div class="prepare-action">
            <v-btn
              :disabled="newItem.description ? false : true"
              @click="saveNew"
              small
              class="white--text text-capitalize"
              color="#79c04d"
            >
              SAVE
              <v-icon>note_add</v-icon>
            </v-btn>
          </div>

          <div class="my-row-small mr-2">
            <v-select
              v-model="dateforSelected"
              :items="datefor"
              background-color="#404855"
              solo
              flat
              prepend-inner-icon="today"
            ></v-select>
          </div>
        </div>

        <div class="prep-body inpmargin-top px-4">
          <TextInput
            placeholder="Your daily comment"
            @imgData="imgData"
            @textData="textData"
            :reset="textInputReset"
            icon
            upload
          />
          <div class="width-full float-left">
            <v-text-field
              prepend-inner-icon="money_off"
              color="#4dbac0"
              v-model="newItem.riskDay"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
              maxlength="13"
              type="number"
              label="Risk for this day (USD)"
              name="risk"
            ></v-text-field>
          </div>

          <v-autocomplete
            prepend-inner-icon="local_offer"
            v-model="newItem.keywords"
            :items="keywords"
            name="keywords"
            :search-input.sync="keyNew"
            itemText="name"
            label="Keywords..."
            multiple
            dense
            color="#4dbac0"
            chips
            class="width-full"
            :menu-props="{ bottom: true, offsetY: true }"
            deletable-chips
          >
            <template v-slot:selection="data">
              <v-chip
                close
                label
                @click="data.select"
                @click:close="remove(data.item)"
              >{{ data.item }}</v-chip>
            </template>
          </v-autocomplete>

          <div class="text-center">
            <vue-feedback-reaction v-model="feedback" />
          </div>
          <div class="mt-4">
            Your personal recommandation*:
            <v-select
              v-model="newItem.estimate"
              :items="recommand"
              background-color="#404855"
              solo
              flat
              class="width-full"
            >
              <template v-slot:selection="data">
                <span
                  v-bind:class="[data.item == 'Buy' || data.item == 'Strong Buy' ? 'long' : data.item == 'Sell' || data.item == 'Strong Sell' ? 'short' : '']"
                >{{ data.item }}</span>
              </template>
              <template v-slot:item="data">
                <span
                  v-bind:class="[data.item == 'Buy' || data.item == 'Strong Buy' ? 'long' : data.item == 'Sell' || data.item == 'Strong Sell' ? 'short' : '']"
                >{{ data.item }}</span>
              </template>
            </v-select>
          </div>Update your price levels
          <v-card class="my-card-color" color="#4dbac0" flat>
            <PriceLevels />
          </v-card>
        </div>
      </div>
      <div class="text-info pa-6" v-else>
        <div v-if="datefor.length == 0">
          <v-icon class="mr-1" color="#b6c1cb">help_outline</v-icon>Trading Diary already initialized.
          <span
            @click="routerMethod('/journal/'+username)"
            class="more"
          >Visit you Trading Diary page.</span>
        </div>
        <div v-if="datefor.length > 0 && datefor[0] == 'Today'">
          <v-icon class="mr-1" color="#b6c1cb">help_outline</v-icon>Trading Diary record for
          <b>Nex Day</b> is already initialized. Would you like
          <span @click="next = true" class="more">
            add record for
            <b>Today?</b>
          </span>
        </div>
        <div v-if="datefor.length > 0 && datefor[0] == 'Next Day'">
          <v-icon class="mr-1" color="#b6c1cb">help_outline</v-icon>Trading Diary record for
          <b>Today</b> is already initialized. Would you like
          <span @click="next = true" class="more">
            add record for
            <b>Next Day?</b>
          </span>
        </div>

        <div class="mt-3">
          <TextInput
            :sendBtn="true"
            placeholder="Idea comment..."
            @imgData="imgData"
            @textData="textData"
            @sending="sendMessage"
            :reset="textInputReset"
            icon
            upload
          />
        </div>
        <div class="width-full float-left mt-4"></div>Update your price levels:
        <v-card class="my-card-color width-full float-left mt-4" color="#4dbac0" flat>
          <PriceLevels />
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { VueFeedbackReaction } from "vue-feedback-reaction";
import TextInput from "@/components/textInputBig.vue";
var moment = require("moment");
//import DiaryHistory from "./item.vue";
import PriceLevels from "@/components/priceLevels/";
import axios from "axios";

export default {
  name: "TradingDiary",
  components: {
    TextInput,
    PriceLevels,
    VueFeedbackReaction
  },

  data() {
    return {
      targetDate: null,
      dataLoaded: false,
      idToday: null,
      idNext: null,
      hrefString: null,
      parentId: null,
      next: false,
      feedback: 0,
      // DATA FROM BEKEND
      //dateforSelected: "Today",
      datefor: [],
      newItem: {
        riskDay: null,
        images: [],
        type: null,
        date: null,
        week: null,
        description: null,
        keywords: [],
        estimate: "No Estimate",
        document: "Diary"
      },
      keyNew: null,
      keywords: ["IBL", "IN RANGE"],
      //keywordsSelected: [],
      recommand: [
        "No Estimate",
        "Strong Buy",
        "Buy",
        "Neutral",
        "Sell",
        "Strong Sell"
      ],

      today: moment().format("dddd MM/DD/YYYY"),
      formHasErrors: false,
      textInputReset: new Date()
    };
  },

  watch: {
    keyNew(val) {
      if (val.slice(-1) == ",") {
        var addKey = val.slice(0, -1);
        this.keywords.push(addKey);
        this.newItem.keywords.push(addKey);
        this.keyNew = null;
      }
    }
  },

  computed: {
    ...mapGetters(["timezone", "username", "settings"])
  },

 mounted() {

    this.getRiskDay();

    this.getExisting();
    this.getNames();
    this.$emit("loading", false);
    /*
    this.sockets.subscribe("PREPARE_CLOSE", data => {
      this.history.unshift(data);
      if (this.history.length > 5) this.history.pop();
    });

    this.sockets.unsubscribe('PREPARE_CLOSEs');
*/
  },

  methods: {
    getRiskDay() {
      if (this.hasOwnNestedProperty(this.settings, "presets.riskDay"))
        this.newItem.riskDay = this.settings.presets.riskDay;
      else this.newItem.riskDay = 2000;
    },
    hasOwnNestedProperty(object, propertyPath) {
      if (!propertyPath) return false;

      var properties = propertyPath.split(".");
      var obj = object;

      for (var i = 0; i < properties.length; i++) {
        var prop = properties[i];

        if (!obj || !obj.hasOwnProperty(prop)) {
          return false;
        } else {
          obj = obj[prop];
        }
      }

      return true;
    },
    routerMethod(path) {
      return this.$router.push({ path: path });
    },
    resetData() {
      this.getExisting();
      this.keyNew = null;
      this.feedback = 0;
      this.textInputReset = new Date();
      this.newItem = {
        images: [],
        type: null,
        date: null,
        week: null,
        description: null,
        keywords: [],
        estimate: "No Estimate",
        document: "Diary"
      };
    },
    diaryDate() {
      if (this.dateforSelected == "Today") {
        this.newItem.type = this.dateforSelected;
        this.newItem.week = moment().week();
        this.targetDate = moment().format("YYYY-MM-DD");
      } else if (this.dateforSelected == "Next Day") {
        this.newItem.type = this.dateforSelected;
        this.newItem.week = moment().week();
        var tomorrou = moment().add("days", 1);
        this.targetDate = tomorrou.format("YYYY-MM-DD");
      } else if (this.dateforSelected == "This Week") {
        this.newItem.type = this.dateforSelected;
        this.newItem.week = moment().week();
      } else if (this.dateforSelected == "Next Week") {
        this.newItem.type = this.dateforSelected;
        this.newItem.week = moment().week() + 1;
      }
    },
    setNames(data) {
      this.keywords = [];
      data.forEach(name => {
        this.keywords.push(name.name);
      });
    },
    getNames() {
      axios
        .post("https://tradeinpool.com:3001/api/request/keywords/")
        .then(response => {
          this.setNames(response.data);
        });
    },
    getExisting() {
      axios
        .post("https://tradeinpool.com:3001/api/request/diaryexists/")
        .then(response => {
          this.datefor = response.data.selector;
          this.idToday = response.data.idToday;
          this.idNext = response.data.idNext;
          this.parentId = this.idToday;
          this.hrefString = response.data.todayString;
          if (!this.idToday) {
            this.parentId = this.idNext;
            this.hrefString = response.data.nextString;
          }
          if (response.data.selector.length > 0)
            this.dateforSelected = response.data.selector[0];
          this.next = false;
          this.dataLoaded = true;
        });
    },

    sendMessage() {
      if (this.newItem.description || this.newItem.images.length > 0) {
        this.$emit("loading", true);
        // requred fields check
        this.formHasErrors = false;
        if (!this.formHasErrors) {
          // prepare api data
          let formData = new FormData();
          formData.append("owner", this.$store.getters.username);
          formData.append("parentType", "Diary");
          formData.append("_parentId", this.parentId);
          formData.append("description", this.newItem.description);
          formData.append("urlDate", this.hrefString);
          formData.append("subtype", "Idea comment");
          this.newItem.images.forEach(fileItem => {
            formData.append("img", fileItem);
          });

          axios
            .post("https://tradeinpool.com:3001/api/add/message/", formData)
            .then(() => {
              this.resetData();
              //var thiis = this;
              this.flash("Idea comment send", "success", {
                timeout: 2000
              });
              setTimeout(() => {
                this.$emit("loading", false);
              }, 1000);
            });
        }
      }
    },

    saveNew() {
      this.$emit("loading", true);
      this.diaryDate();
      // requred fields check
      this.formHasErrors = false;

      if (!this.formHasErrors) {
        // prepare api data
        let formData = new FormData();
        formData.append("parentType", this.newItem.document);
        formData.append("parentId", null);
        formData.append("description", this.newItem.description);
        formData.append("estimate", this.newItem.estimate);
        formData.append("urlDate", this.targetDate);
        formData.append("dateString", this.targetDate);
        //formData.append("date", this.newItem.date);
        formData.append("type", this.newItem.type);
        formData.append("week", this.newItem.week);
        formData.append("riskDay", this.newItem.riskDay);
        formData.append("feeling", this.feedback);
        //create string from array
        var keyString = "";
        this.newItem.keywords.forEach(word => {
          keyString += word + ",";
        });
        if (this.newItem.keywords.length > 0) {
          keyString = keyString.substring(0, keyString.length - 1);
        }

        formData.append("keywords", keyString);

        this.newItem.images.forEach(fileItem => {
          formData.append("img", fileItem);
        });

        axios
          .post("https://tradeinpool.com:3001/api/add/diary/", formData)
          .then(() => {
            this.$store.dispatch("updateUserPreset", {
              section: "riskDay",
              value: this.newItem.riskDay
            });
            this.getExisting();
            this.resetData();
            //var thiis = this;
            this.flash("Record saved to trading journal.", "success", {
              timeout: 2000
            });
            setTimeout(() => {
              this.$emit("loading", false);
              this.getRiskDay()
            }, 1000);
          });
      }
    },

    imgData(data) {
      this.newItem.images = data;
    },
    textData(data) {
      this.newItem.description = data;
    },
    remove(item) {
      const index = this.newItem.keywords.indexOf(item);
      if (index >= 0) this.newItem.keywords.splice(index, 1);
    }
  },

  sockets: {
    TIMELINE: function(data) {
      if (data.user.username == this.username) {
        if (data.type == "Trade Open" || data.type == "Trade Prepare")
          this.getExisting();
        this.diaryDate();
      }
    }
  }
};
</script>







<style scoped>
.minwidth {
  width: 50%;
  float: left;
}

.list-enter-active,
.list-leave-active,
.list-move {
  transition: 500ms cubic-bezier(0.59, 0.12, 0.34, 0.95);
  transition-property: opacity, transform;
}

.list-enter {
  opacity: 0;
  transform: translateX(50px) scaleY(0.5);
}

.list-enter-to {
  opacity: 1;
  transform: translateX(0) scaleY(1);
}

.list-leave-active {
  position: absolute;
}

.list-leave-to {
  opacity: 0;
  transform: scaleY(0);
  transform-origin: center top;
}

.history {
  margin-top: 30px;
  width: 100%;
  float: left;
}
.descInput input[type="text"] {
  margin-right: 15px;
  height: 30px;
  width: 100%;
  border-radius: 20px;
  border: 0px;
  padding-left: 21px;
  background-color: #404855;
  color: white;
  font-size: 12px;
  margin-top: 15px;
}

*:focus {
  outline: none;
}

.short {
  color: #e62163;
  font-weight: bold;
}

.long {
  color: #79c04d;
  font-weight: bold;
}
.my-row {
  width: 48%;
  float: left;
}
.my-row-small {
  width: 150px;
  float: right;
}

.inpmargin-left {
  margin-left: 2%;
}
.inpmargin-top {
  margin-top: 10px;
}
.inpmargin-right {
  margin-right: 2%;
}

.descpInput {
  float: left;
  width: 100%;
}

.descpInput input[type="text"] {
  height: 30px;
  border-radius: 3px;
  background-color: #404855;
  color: white;
  font-size: 12px;
  font-weight: bold;
  width: 100%;
  padding-left: 13px;
}

.pre-trade {
  width: 100%;
  float: left;
  background: #2d3540;
  padding: 13px 15px 15px 15px;
  border-radius: 3px;
  margin-bottom: 1px;
  font-size: 12px;
}

.head-main {
  color: #4dbac0;
}
.prepare-action {
  float: right;
  color: white;
}
.smaller {
  height: 30px;
}
.head-content {
  float: left;
  color: #25a7f9;
}

.head-content2 {
  float: right;
  padding-top: 2px;
}

.prep-body {
  float: left;
  width: 100%;
  color: white;
}

.div-table {
  display: table;
  width: auto;
  border-spacing: 5px; /* cellspacing:poor IE support for  this */
}
.div-table-row {
  display: table-row;
  width: auto;
  clear: both;
}
.div-table-col {
  float: left; /* fix for  buggy browsers */
  display: table-column;
}

.noteInput input[type="text"] {
  margin-right: 15px;
  height: 30px;
  border-radius: 15px;
  border: 0px;
  padding-left: 21px;
  background-color: #404855;
  color: white;
  font-size: 12px;
}

.my-inputs {
  background-color: #404855;
  border: 0px;
  color: white;
  border-radius: 3px;
  font-weight: bold;
}
.unselectable {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
::-moz-selection {
  background: transparent;
}
::selection {
  background: transparent;
}

.select_box {
  float: left;
  background-color: #404855;
  border-radius: 3px;
  overflow: hidden;
  border: 0px;
  position: relative;
}
.input_box {
  float: left;
  background-color: #404855;
  border-radius: 3px;
  overflow: hidden;
  border: 0px;
  position: relative;
  font-size: 12px;
  padding: 6px;
}

.select_box:after {
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-top: 6px solid white;
  position: absolute;
  top: 40%;
  right: 10px;
  content: "";
  z-index: 98;
}
.select_box select {
  border: 0;
  position: relative;
  z-index: 99;
  background: none;
  font-size: 12px;
}
.margined-r {
  margin-right: 10px;
}

div.v-select-list div[role="list"] div[role="listitem"]:hover {
  background-color: #00857a;
}
</style>
